import React from "react";
import Card from "react-bootstrap/Card";
import ShowMoreText from "react-show-more-text";
import projImg7 from "../../assets/img/7.png";
import projectimage7 from "../../assets/img/p7.png";

const PreviousCard7 = () => {
    return (
        <Card className="CARD2" bg="dark">
              {/* <Card.Title><h2>Quantifying scientific impact with correction for citation gaming</h2></Card.Title> */}

              <Card.Img variant="top" src={projectimage7} />

              <Card.Body>
                <Card.Text>
                  {" "}
                  <img className="img2" src={projImg7} />{" "}
                  <p className="text7">Levente Török </p>
                  <br />
                  <p className="text8">
                    Machine Learning Engineer
                    <br /> Snapchat
                  </p>
                </Card.Text>
                <ShowMoreText lines={1}>
                  <div>
                    The project aims at developing a method to evaluate the
                    impact of scientific research while accounting for the
                    practice of citation manipulation or 'citation gaming.'
                    Citation gaming involves authors manipulating citations to
                    artificially boost their impact metrics. The proposed method
                    should adjust the citation counts of articles based on the
                    proportion of self-citations and citations from suspect
                    sources. This approach allows for a more accurate evaluation
                    of the impact of research and can be useful for funding
                    agencies, research institutions, and researchers themselves
                    in assessing the value of scientific publications.
                    <br />
                    <br />
                    Related literature:{" "}
                    <ul>
                      <li>
                        Chakraborty, J., Pradhan, D. K., & Nandi, S. (2022).
                        Research misconduct and citation gaming: A critical
                        review on characterization and recent trends of research
                        manipulation.
                        <span className="text9">
                          {" "}
                          Data Management, Analytics and Innovation: Proceedings
                          of ICDMAI 2021
                        </span>
                        , Volume 2, 485-492.
                      </li>
                      <li>
                        {" "}
                        Fister Jr, I., Fister, I., & Perc, M. (2016). Toward the
                        discovery of citation cartels in citation networks.
                        <span className="text9"> Frontiers in Physics </span>, 4, 49.
                      </li>
                      <li>
                        {" "}
                        Senanayake, U., Piraveenan, M., & Zomaya, A. (2015). The
                        pagerank-index: Going beyond citation counts in
                        quantifying scientific impact of researchers.
                        <span className="text9"> PloS one </span>, 10(8), e0134794.
                      </li>
                      <li>
                        {" "}
                        Gao, C., Wang, Z., Li, X., Zhang, Z., & Zeng, W. (2016).
                        PR-index: using the h-index and PageRank for determining
                        true impact. <span className="text9"> PloS one </span>, 11(9),
                        e0161755.
                      </li>
                      <li>
                        {" "}
                        Gasparyan, A. Y., Yessirkepov, M., Duisenova, A.,
                        Trukhachev, V. I., Kostyukova, E. I., & Kitas, G. D.
                        (2018). Researcher and author impact metrics: variety,
                        value, and context.
                        <span className="text9">
                          {" "}
                          Journal of Korean Medical Science{" "}
                        </span>
                        , 33(18).
                      </li>
                      <li>
                        {" "}
                        Bai, X., Pan, H., Hou, J., Guo, T., Lee, I., & Xia, F.
                        (2020). Quantifying success in science: An overview.
                        <span className="text9"> IEEE Access </span>, 8,
                        123200-123214.
                      </li>
                      <li>
                        {" "}
                        Vergoulis, T., Kanellos, I., Atzori, C., Mannocci, A.,
                        Chatzopoulos, S., Bruzzo, S. L., ... & Manghi, P. (2021,
                        April). Bip! db: A dataset of impact measures for
                        scientific publications.
                        <span className="text9">
                          {" "}
                          In Companion Proceedings of the Web Conference 2021{" "}
                        </span>
                        (pp. 456-460).
                      </li>{" "}
                    </ul>
                  </div>
                </ShowMoreText>
              </Card.Body>
            </Card>
    );
};

export default PreviousCard7;
